
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.814 2.101l5.584 5.584L9.55 8.838l9.715 9.714 3.348 3.348-1.414 1.414-3.662-3.662C16.001 20.46 14.165 21 12 21c-8.571 0-12-8.471-12-8.471l.001-.006.012-.044c.118-.451 1.083-3.847 3.903-6.447L1.4 3.515l1.414-1.414zm3.774 6.602A5.663 5.663 0 005.524 12c0 3.313 2.899 6 6.476 6a6.85 6.85 0 003.136-.75l-1.57-1.568a4 4 0 01-5.247-5.249l-1.73-1.73zM12 3c9.714 0 12 9.529 12 9.529s-.988 2.44-3.229 4.702l-2.833-2.833A5.606 5.606 0 0018.476 12c0-3.313-2.899-6-6.476-6-.746 0-1.462.117-2.128.332L7.38 3.842C8.692 3.318 10.222 3 12 3zm0 5a4 4 0 013.977 4.435l-4.412-4.412C11.708 8.008 11.853 8 12 8z","fill":"#2A333D"}})])
          )
        }
      }
    